import { tdeBaseUrl } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"
import { adaptTrailerLocation } from "../utilities/auditDealerAdapters"

const initialState = {
  trailerLocations: [],
  trailerLocationsFetching: false,
  trailerLocation: null,
}

const createTrailersSlice = (set, get) => ({
  ...initialState,
  fetchTrailerLocations: async (dfpBranchId = get().selectedBranch?.[0]) => {
    if (!get().tdeRequestHeaders) { return }
    if (!dfpBranchId) { return }

    set(() => ({ trailerLocationsFetching: true }))
    try {
      const params = new URLSearchParams({ dfp_branch_id: dfpBranchId })
      const response = await fetch(
        `${tdeBaseUrl}/api/v2/locations?${params.toString()}`,
        { headers: get().tdeRequestHeaders }
      )
      const data = await response.json()
      set(() => ({
        trailerLocations: (data.data ?? []).map(adaptTrailerLocation),
        trailerLocationsFetching: false,
      }))
    } catch (err) {
      set(() => ({ trailerLocationsFetching: false }))
      rollbarLogger(get().user).logError('Unable to retrieve trailer locations at this time.', err)
    }
  },
  fetchTrailerLocation: async (locationId, onComplete) => {
    if (!get().tdeRequestHeaders) { return }
    if (!locationId) { return }

    try {
      const response = await fetch(
        `${tdeBaseUrl}/api/v2/locations/${locationId}`,
        { headers: get().tdeRequestHeaders }
      )
      const data = await response.json()
      set(() => ({ trailerLocation: data.data ?? null }))
    } catch (err) {
      rollbarLogger(get().user).logError('Unable to retrieve trailer location at this time.', err)
    } finally {
      onComplete?.()
    }
  },
  resetTrailersSlice: () => set(initialState),
})

export default createTrailersSlice
